import { charset7bit, charset7bitext } from '@/config/charsets.js'

import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import cloneDeep from 'lodash/cloneDeep'

export const characterVariables = {
  props: {
    text: String,
    error: Boolean,
  },
  components: {
    MessageVariables: () => import('@/modules/campanhas/views/components/edit/MessageVariables.vue'),
  },
  data: () => ({
    charsUsed: 0,
    bestItem: 1,
  }),
  computed: {
    ...mapGetters({
      mariaCampaign: 'mariaCampaign',
    }),
    offer() {
      return this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
    },
    today() {
      return DateTime.now().toFormat('dd/MM/yyyy')
    },
    isMariaCampaign() {
      return this.$route.name === 'Channels'
    },
    textLocal: {
      get() {
        return this.value || ''
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    insideVariables() {
      switch (this.offer) {
        case 'general':
          return ['{nome produto}', '{preço 1}', '{preço 2}', '{inicio validade}', '{fim validade}']
        case 'percentage':
          return ['{nome produto}', '{desconto}', '{inicio validade}', '{fim validade}']
        case 'dynamic_pricing_percentage':
          return ['{nome produto}', '{desconto}', '{inicio validade}', '{fim validade}']
        case 'takepay':
          return ['{nome produto}', '{leve}', '{pague}', '{inicio validade}', '{fim validade}']
        case 'combo':
          return ['{nome produto}', '{nome do combo}', '{inicio validade}', '{fim validade}']
      }
    },
    variables() {
      return [
        {
          clipboardText: '[primeiro nome]',
          text: 'Primeiro nome',
          description: '- Exibe o primeiro nome do cliente.',
          example: 'João',
          charQuantity: 10,
        },
        ...(this.isMariaCampaign
          ? [
              {
                clipboardText: this.getClipboardTextBestItem(),
                text: this.offer !== 'combo' ? 'Melhor produto' : 'Melhor combo',
                description: '- Exibe, dos produtos em promoção, qual o consumidor tem mais chance de comprar seguindo os critérios incluso na campanha.',
                charQuantity: this.bestProductCharQuantity,
              },
            ]
          : []),
        {
          clipboardText: '[ultimo nome]',
          text: 'Último nome',
          description: '- Exibe o último nome do cliente.',
          example: 'Silva',
          charQuantity: 20,
        },
        {
          clipboardText: '[data hoje]',
          text: 'Data de hoje',
          description: '- Exibe a data de hoje.',
          example: this.today,
          charQuantity: 10,
        },
        {
          clipboardText: '[dia aniversario]',
          text: 'Dia do aniversário',
          description: '- Exibe a data do aniversário do consumidor.',
          example: this.today,
          charQuantity: 8,
        },
        {
          clipboardText: '[mes]',
          text: 'Mês atual',
          description: '- Exibe o mês atual.',
          example: DateTime.now().toFormat('LLLL'),
          charQuantity: 9,
        },
        {
          clipboardText: '[link de optout]',
          text: 'Link de optout',
          description: '- Renderiza a URL para optout de recebimento e-mail.',
          channels: ['email'],
          example: 'https://www.mercafacil.com',
          charQuantity: 200,
        },
        ...(this.isMariaCampaign
          ? [
              {
                clipboardText: '{nome produto}',
                variableWithinVariable: true,
                charQuantity: this.sizeBestProducts,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'general'
          ? [
              {
                clipboardText: '{preço 1}',
                variableWithinVariable: true,
                charQuantity: 7,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'general'
          ? [
              {
                clipboardText: '{preço 2}',
                variableWithinVariable: true,
                charQuantity: 7,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'percentage'
          ? [
              {
                clipboardText: '{desconto}',
                variableWithinVariable: true,
                charQuantity: 3,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'dynamic_pricing_percentage'
          ? [
              {
                clipboardText: '{desconto}',
                variableWithinVariable: true,
                charQuantity: 3,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'takepay'
          ? [
              {
                clipboardText: '{leve}',
                variableWithinVariable: true,
                charQuantity: 3,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'takepay'
          ? [
              {
                clipboardText: '{pague}',
                variableWithinVariable: true,
                charQuantity: 3,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'combo'
          ? [
              {
                clipboardText: '{nome do combo}',
                variableWithinVariable: true,
                charQuantity: this.sizeBestCombo,
              },
            ]
          : []),
        ...(this.isMariaCampaign
          ? [
              {
                clipboardText: '{inicio validade}',
                variableWithinVariable: true,
                charQuantity: 8,
              },
            ]
          : []),
        ...(this.isMariaCampaign
          ? [
              {
                clipboardText: '{fim validade}',
                variableWithinVariable: true,
                charQuantity: 8,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer !== 'combo'
          ? [
              {
                clipboardText: 'primeiro melhor produto ',
                variableWithinVariable: true,
                charQuantity: this.isSms ? -1 : -2,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer !== 'combo'
          ? [
              {
                clipboardText: 'segundo melhor produto ',
                variableWithinVariable: true,
                charQuantity: this.isSms ? -1 : -2,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer !== 'combo'
          ? [
              {
                clipboardText: 'terceiro melhor produto ',
                variableWithinVariable: true,
                charQuantity: this.isSms ? -1 : -2,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'combo'
          ? [
              {
                clipboardText: 'primeiro melhor combo ',
                variableWithinVariable: true,
                charQuantity: this.isSms ? -1 : -2,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'combo'
          ? [
              {
                clipboardText: 'segundo melhor combo ',
                variableWithinVariable: true,
                charQuantity: this.isSms ? -1 : -2,
              },
            ]
          : []),
        ...(this.isMariaCampaign && this.offer === 'combo'
          ? [
              {
                clipboardText: 'terceiro melhor combo ',
                variableWithinVariable: true,
                charQuantity: this.isSms ? -1 : -2,
              },
            ]
          : []),
      ]
    },
    smsVariables() {
      const variables = this.variables.map((variable) => {
        return {
          ...variable,
          clipboardText: variable.clipboardText[0] === '{' || variable.clipboardText[0] === '[' ? variable.clipboardText : `[${variable.clipboardText}`,
        }
      })
      return variables
    },
    sizeBestProducts() {
      if (this.offer === 'combo') return this.sizeBestCombo

      let products = []
      if (this.offer === 'general') products = this.mariaCampaign.offer_sales
      if (this.offer === 'takepay') products = this.mariaCampaign.takepay_offer_sales
      if (this.offer === 'percentage') products = this.mariaCampaign.percentage_offer_sales
      if (this.offer === 'dynamic_pricing_percentage') products = this.mariaCampaign.dynamic_pricing_percentage_offer_sales

      if (!products) return 0
      let allProducts = []
      products.forEach((offer) => {
        if (offer.isGroup) {
          return allProducts.push(...offer.products)
        }
        return allProducts.push(offer)
      })
      return allProducts
        .map((product) => product.name.length)
        .sort((a, b) => a - b)
        .pop()
    },
    sizeBestCombo() {
      const combo = this.mariaCampaign.combo_offer_sales
      if (!combo) return 0
      return combo
        .map((combo) => combo.name.length)
        .sort((a, b) => a - b)
        .pop()
    },
    bestProductCharQuantity() {
      switch (this.offer) {
        case 'general':
          return 58 + this.sizeBestProducts
        case 'percentage':
          return 54 + this.sizeBestProducts
        case 'dynamic_pricing_percentage':
          return 54 + this.sizeBestProducts
        case 'takepay':
          return 60 + this.sizeBestProducts
        case 'combo':
          return 34 + this.sizeBestCombo
      }
    },
    getBestProductText() {
      switch (this.offer) {
        case 'general':
          return 'melhor produto {nome produto} de {preço 1}, por {preço 2}'
        case 'percentage':
          return 'melhor produto {nome produto} com {desconto} de desconto'
        case 'dynamic_pricing_percentage':
          return 'melhor produto {nome produto} com {desconto} de desconto'
        case 'takepay':
          return `melhor produto levando {leve} {nome produto} voce paga {pague}`
        case 'combo':
          return 'melhor combo {nome do combo}'
      }
    },
  },
  methods: {
    reset() {
      this.charsUsed = 0
    },
    getClipboardTextBestItem(bestItem) {
      if (bestItem) this.bestItem = bestItem

      const labelsClipBoardBestItem = {
        1: 'primeiro',
        2: 'segundo',
        3: 'terceiro',
      }

      return `[${labelsClipBoardBestItem[this.bestItem]} ${this.getBestProductText}, do dia {inicio validade} ate {fim validade}]`
    },
    // Method to update the amount of characters used
    updateCharsUsedLength(isSms) {
      this.reset()
      const charsArray = this.messageWithVariable(this.textLocal, isSms)
      let coding = '7bit'

      for (const [index, char] of charsArray.entries()) {
        // if it is sms
        if (charset7bit.indexOf(char) >= 0 && isSms) this.charsUsed += 1
        // if it is sms and a special character
        else if (charset7bitext.indexOf(char) >= 0 && isSms) this.charsUsed += 2
        // if it is a variable
        else if (char.length > 1) {
          const { charQuantity } = isSms
            ? this.smsVariables.find((variable) => variable.clipboardText === char)
            : this.variables.find((variable) => variable.clipboardText === char)
          this.charsUsed += charQuantity
        } else {
          if (!(isSms && char === ']' && this.getSubvariableIndexesInterval().find((el) => el.includes(index)))) {
            coding = '16bit'
          }
          this.charsUsed += 1
        }
      }

      if (isSms) this.countCharsAvailable(coding)
    },
    // Separates the message by variables and strings and returns the array
    messageWithVariable(text = '', isSms) {
      let message = cloneDeep(text)
      const variaveis = isSms ? this.smsVariables.map((object) => object.clipboardText) : this.variables.map((object) => object.clipboardText)
      for (let variavel of variaveis) {
        if (message.includes(variavel)) {
          message = message.split(variavel).join('+|+' + variavel + '+|+')
        }
      }
      let messageArray = message.split('+|+')
      let novoArray = []

      const isInsideInterval = (index) => {
        const indexes = []
        const indexesStart = []
        novoArray.forEach((char, index) => {
          const offer = this.offer === 'combo' ? 'combo' : 'produto'
          if ([`[primeiro melhor ${offer} `, `[segundo melhor ${offer} `, `[terceiro melhor ${offer} `].includes(char)) {
            indexesStart.push(index)
          }
        })
        indexesStart.forEach((indexStart) => {
          if (indexStart < 0) {
            indexes.push([-1, -1])
          } else {
            indexes.push([
              indexStart,
              novoArray.findIndex((char, index) => {
                return char === ']' && index > indexStart
              }),
            ])
          }
        })

        return indexes.find(([start, final]) => final > -1 && index >= start && index <= final)
      }

      for (let block of messageArray) {
        if (variaveis.includes(block)) {
          novoArray.push(block)
        } else {
          for (let char of block.split('')) {
            novoArray.push(char)
          }
        }
      }

      let formattedArray = []
      for (let [index, block] of novoArray.entries()) {
        if (isInsideInterval(index) && this.insideVariables.includes(block)) {
          formattedArray.push(block)
        } else if (variaveis.includes(block)) {
          if (this.insideVariables.includes(block)) {
            for (let char of block.split('')) {
              formattedArray.push(char)
            }
          } else {
            const offer = this.offer === 'combo' ? 'combo' : 'produto'
            if (!isInsideInterval(index) && [`[primeiro melhor ${offer} `, `[segundo melhor ${offer} `, `[terceiro melhor ${offer} `].includes(block)) {
              for (let char of block.split('')) {
                formattedArray.push(char)
              }
            } else {
              formattedArray.push(block)
            }
          }
        } else {
          for (let char of block.split('')) {
            formattedArray.push(char)
          }
        }
      }

      return formattedArray
    },
    lengthCounter(text, maxTextLength) {
      const { variableText, variableTextSum } = this.variablesCounter(text)
      const counter = maxTextLength - variableTextSum + variableText.join('').length

      return counter
    },
    // returns the number of characters and array of variables
    variablesCounter(text) {
      const variableArray = this.variables.map((variable) => variable.clipboardText)
      const variableText = this.messageWithVariable(text).filter((array) => variableArray.includes(array))
      const variableTextSum = variableText.reduce((accumulator, current) => {
        const { charQuantity } = this.variables.find((variable) => variable.clipboardText === current)
        accumulator += charQuantity
        return accumulator
      }, 0)

      return { variableText, variableTextSum, variableArray }
    },
  },
}
